import { generateInitialState } from "@/utils/redux/generateInitialState";
import { StoreState } from "./type";
import { generateInitialStateWithFilter } from "@/utils/redux/generateInitialStateWithFilter";
import { defaultStoreMeta } from "@/utils/store/parseStoreMeta";

export const storeInitialState: StoreState = {
  store_setting: generateInitialState<any>({
    data: JSON.parse(JSON.stringify(defaultStoreMeta))
  }),
  category_list: generateInitialStateWithFilter({
    data: []
  }),
  send_mail_contact: generateInitialState<any>({
    data: {}
  }),
  discount_detail: generateInitialState<any>({
    data: {}
  }),
  isDesktop: false
}